import {resetWorkspace} from "../../store/modules/roster/actions";

const RosteringToolLayout = () => import('./RosteringToolLayout/RosteringToolLayout')
const Welcome = () => import('./Pages/Welcome/Welcome')
const TeamSelection = () => import('./Pages/TeamSelection/TeamSelection')
const Success = () => import('./Pages/Success/Success')
const RosterCoaches = () => import('./Pages/RosterCoaches/RosterCoaches')
const RosterAthletes = () => import('./Pages/RosterAthletes/RosterAthletes')
const GatherInfo = () => import('./Pages/GatherInfo/GatherInfo')
const FinalReview = () => import('./Pages/FinalReview/FinalReview')
const BasePage = () => import('./RosteringToolLayout/BasePage')
import rosterStore from "@/store";
const  UserAuthentication =   () => import("@/components/Roster/Pages/UserAuthentication/UserAuthentication.vue");
const UserLogin = () => import("@/components/Roster/components/Auth/Login/UserLogin.vue");
const UserRegistration = () => import('./components/Auth/Registration/UserRegistration.vue');
const RosterSource = () => import("@/components/Roster/components/Welcome/RosterSource.vue");
const ManualRostering = () => import("@/components/Roster/components/RosterAthletes/ManualRostering.vue");
const IntegratedRostering = () => import("@/components/Roster/components/RosterAthletes/IntegratedRostering.vue");

export default {
    path: '/roster/:token',
    component: RosteringToolLayout,
    name: "Roster/Event",
    async beforeEnter(to, from, next) {
        const { token, teamId } = to.params
        await rosterStore.dispatch('roster/retrieveEventId', { token, teamId })
        next()
    },
    children: [
        {
            path: ':teamId',
            component: BasePage,
            name: "Roster/Event/Base",
            async beforeEnter(to, from, next) {
                const { teamId } = to.params
                await rosterStore.dispatch('roster/setCurrentTeam', { teamId })
                window.onbeforeunload = () => 'Are you sure you want to leave?'
                next()
            },
            children: [
                {
                    path: 'welcome',
                    component: Welcome,
                    name: "Roster/Event/TeamWelcome",
                },
                {
                    path: 'source',
                    component: RosterSource,
                    name: "Roster/Event/Source",
                },
                {
                    path: 'auth',
                    component: UserAuthentication,
                    name: "Roster/Event/Auth",
                    children: [
                        {
                            path: 'login',
                            component: UserLogin,
                            name: "Roster/Event/Auth/Login",
                        },
                        {
                            path: 'register',
                            component: UserRegistration,
                            name: "Roster/Event/Auth/Register",
                        }
                    ]
                },
                {
                    path: 'success',
                    component: Success,
                    name: "Roster/Event/Success",
                },
                {
                    path: 'roster-coaches',
                    component: RosterCoaches,
                    name: "Roster/Event/RosterCoaches",
                },
                {
                    path: 'roster-athletes',
                    component: RosterAthletes,
                    name: "Roster/Event/RosterAthletes",
                    children: [
                        {
                            path: 'manual',
                            component: ManualRostering,
                            name: "Roster/Event/RosterAthletes/Manual",
                        },
                        {
                            path: 'integrated',
                            component: IntegratedRostering,
                            name: "Roster/Event/RosterAthletes/Integrated",
                        }
                    ]
                },
                {
                    path: 'gatherInfo',
                    component: GatherInfo,
                    name: "Roster/Event/GatherInfo",
                },
                {
                    path: 'finalReview',
                    component: FinalReview,
                    name: "Roster/Event/FinalReview",
                },

            ]

        },
        {
            path: '',
            component: TeamSelection,
            name: "Roster/Event/TeamSelection",
            async beforeEnter(to, from, next) {
                window.onbeforeunload = function () {
                    // blank function do nothing
                }
                next()
            },
        },
        
    ],
}
